import * as Yup from "yup";
import {
  firstNameSchema,
  lastNameSchema,
  emailSchema,
  passwordSchema,
} from "../../../../utils/validationSchemas";

export const INITIAL_KID_STATE = {
  _id: "",
  _status: "new",
  firstName: "",
  lastName: "",
  username: "",
  age: "",
  password: "",
  email: "",
};
export const validationSchema = Yup.object().shape({
  kids: Yup.array().of(
    Yup.object().shape({
      firstName: firstNameSchema,
      lastName: lastNameSchema,
      username: Yup.string().when("age", {
        is: (age) => age > 12,
        then: () => Yup.string().nullable().notRequired(),
        otherwise: () =>
          Yup.string()
            .required("Username is required")
            .min(5, "Username must be at least 5 characters")
            .max(15, "Username must not exceed 15 characters")
            .matches(/^\S+$/, "Username must not contain spaces")
            .test(
              "unique-username",
              "Username must be unique",
              function (value) {
                if (!value) return true;
                const { from } = this;
                const kids = from?.[1]?.value?.kids;
                if (!kids) return true;
                const duplicates = kids.filter(
                  (kid) => kid.username?.toLowerCase() === value.toLowerCase(),
                );
                return duplicates.length <= 1;
              },
            ),
      }),
      age: Yup.number()
        .typeError("Age must be a number")
        .required("Age is required")
        .positive("Must be valid")
        .integer("Must be valid")
        .max(100, "Age cannot be more than 100"),
      email: Yup.string().when("age", {
        is: (age) => age > 12,
        then: () =>
          emailSchema.test(
            "unique-email",
            "Email must be unique",
            function (value) {
              if (!value) return true;
              const { from } = this;
              const kids = from?.[1]?.value?.kids;
              if (!kids) return true;
              const duplicates = kids.filter(
                (kid) =>
                  kid.age > 12 &&
                  kid.email?.toLowerCase() === value.toLowerCase(),
              );
              return duplicates.length <= 1;
            },
          ),
        otherwise: () => Yup.string().nullable().notRequired(),
      }),

      password: Yup.string().when(["age", "_status"], {
        is: (age, _status) => (age <= 12 || !age) && _status !== "old",
        then: () => passwordSchema,
        otherwise: () => Yup.string().nullable().notRequired(),
      }),
    }),
  ),
  progressAssignedTo: Yup.number().nullable().notRequired(),
});
